/* eslint-disable @typescript-eslint/naming-convention */
export enum EPlatform {
  WEB_ADMIN = 'web_admin',
  WEB_CLIENT = 'web_client',
  WEB_SHARED = 'web_shared',
  APP = 'app',
}
